import { ContentMetadataStore, ContentMetadataStoreLoadingState } from '../types/video-feed-types';

export const defaultLoadingState: ContentMetadataStoreLoadingState = {
  videoFeedsLoading: true,
  speakerAnalysisLoading: false,
  transcriptLoading: false,
  clipDataLoaded: false
};

export const ensureContentEntry = (data: ContentMetadataStore, contentId: string): void => {
  if (!data[contentId]) {
    data[contentId] = {
      videoFeeds: [],
      metadata: {
        transcript: [],
        speakerAnalysis: undefined,
        speakerDetails: undefined,
        alignedRecordings: undefined,
        sessionDetails: undefined
      },
      loading: { ...defaultLoadingState }
    };
  }
};
